import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '@cyberint/common-utils';
import { InlinePopper } from '../Poppers';
import { Tag, TagsContainer, TagVariants } from '../Tag';
import * as S from './styled';

const TEST_ID = 'multi-values';

export const MultiValueChips = ({ values, optionsByValue, count = 1, clearValue, testId }) => {
  const chips = useMemo(
    () =>
      values.map(v => {
        const option = optionsByValue?.[v];
        const clearHandler = () => clearValue?.(v);
        return (
          <Tag
            key={v}
            onClose={clearHandler}
            testId={`tag-${v}-${testId || TEST_ID}`}
            variant={TagVariants.CHIP}
            dotColor={option?.dotColor}
            content={
              <S.StyledTagOption>
                {option?.icon}
                {option?.label || v}
              </S.StyledTagOption>
            }
          />
        );
      }),
    [values, clearValue, optionsByValue, testId]
  );

  return <TagsContainer chips={chips} count={count} />;
};

MultiValueChips.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  count: PropTypes.number,
  testId: PropTypes.string,
  optionsByValue: PropTypes.shape({}),
  clearValue: PropTypes.func
};

export const SelectedCount = ({ values, optionsByValue }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const showPopper = e => setAnchorEl(e.currentTarget);
  const hidePopper = () => setAnchorEl(null);

  const chips = values?.map(v => {
    const option = optionsByValue?.[v];
    return (
      <Tag
        key={v}
        variant={TagVariants.CHIP}
        content={
          <S.StyledTagOption>
            {option?.icon}
            {option?.label}
          </S.StyledTagOption>
        }
      />
    );
  });

  return (
    <div>
      <div onMouseEnter={showPopper} onMouseLeave={hidePopper}>
        {t('common.selected', { count: values.length })}
      </div>
      <InlinePopper placement="bottom-start" open={!!anchorEl} anchorEl={anchorEl}>
        <S.MultiValueTooltipWrapper>
          <TagsContainer chips={chips} count={5} />
        </S.MultiValueTooltipWrapper>
      </InlinePopper>
    </div>
  );
};
SelectedCount.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  optionsByValue: PropTypes.shape({})
};
